<div class="flex flex-col md:flex-row gap-4 items-start h-full">
    <div class="flex-1 w-full min-w-0 h-full">
        <div class="grid-debitos w-full h-full flex flex-col">
            <p-card class="w-full h-full flex flex-col" styleClass="flex-1 flex flex-col h-full min-h-[100vh]" [style]="{ display: 'flex', flexDirection: 'column', height: '100%' }">
                <app-header-divisor class="w-full flex" [label]="'Demandas'" [icon]="'pi pi-id-card'">
                    <div ngProjectAs="first-action-button" class="flex items-center gap-3">
                        <p-button icon="pi pi-plus-circle" (click)="openNewTicketModal()" [text]="false" [rounded]="false" label="Adicionar" pTooltip="Nova Anotação"></p-button>
                    </div>
                </app-header-divisor>

                <div class="flex justify-between items-center">
                    <div class="mx-auto">
                        <p-selectbutton [options]="options" [ngModel]="selectedValue" (ngModelChange)="onChange($event)" optionLabel="label" optionValue="value" [unselectable]="true" class="flex flex-wrap justify-center gap-2" styleClass="w-33">
                            <ng-template let-option pTemplate="item">
                                <div class="flex items-center">
                                    <span>{{ option.label }}</span>
                                </div>
                            </ng-template>
                        </p-selectbutton>
                    </div>
                </div>
                <div class="pt-5 flex-1 flex flex-col">
                    @switch (selectedValue) {
                        @case ('demandas') {
                            <ng-container *ngTemplateOutlet="demandas"></ng-container>
                        }
                        @case ('cancelados') {
                            <ng-container *ngTemplateOutlet="canceladas"></ng-container>
                        }
                        @case ('finalizados') {
                            <ng-container *ngTemplateOutlet="finalizadas"></ng-container>
                        }
                    }
                </div>
            </p-card>
        </div>
    </div>
</div>

<ng-template #demandas>
    <!-- Kanban Grid -->
    <div (click)="movingTicketId.set(null)" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 flex-1 h-full min-h-0 pb-4 overflow-x-visible" cdkDropListGroup>
        @for (col of columns; track col.id) {
            <div class="h-full flex flex-col rounded-2xl border border-slate-200/50 dark:border-slate-700/50 shadow-sm transition-colors" [class]="col.color">
                <div class="p-4 flex justify-between items-center border-b border-slate-200/30 dark:border-slate-700/30 bg-white/40 dark:bg-slate-900/40 backdrop-blur-sm rounded-t-2xl flex-shrink-0">
                    <div class="flex items-center gap-2">
                        <span class="font-bold uppercase tracking-wider text-[11px] text-slate-500 dark:text-slate-400">{{ col.title }}</span>
                        <span class="bg-white/80 dark:bg-slate-800/80 border border-slate-200/50 dark:border-slate-700/50 text-slate-600 dark:text-slate-300 text-[10px] font-bold px-2 py-0.5 rounded-full shadow-sm">
                            {{ getTicketsByStatus(col.id).length }}
                        </span>
                    </div>
                </div>

                <div [id]="col.id" cdkDropList [cdkDropListData]="col.id" (cdkDropListDropped)="onDrop($event)" class="p-3 flex-1 flex flex-col gap-3 overflow-y-auto">
                    @for (ticket of getTicketsByStatus(col.id); track ticket.id) {
                        <app-card-container [light]="false" cdkDrag class="p-4 active:cursor-grabbing group relative pb-11">
                            <div class="flex items-center gap-2 mb-4">
                                <p-avatar image="images/logos/logo.png" shape="circle" size="large" class="shadow-sm border border-slate-100"></p-avatar>
                                <div class="flex flex-col ms-3">
                                    <span class="text-[11px] font-bold text-slate-700 dark:text-slate-200 leading-tight">{{ ticket.data.assignee || 'Usuário' }}</span>
                                    <span class="text-[10px] text-slate-400 font-medium leading-tight">CFM</span>
                                </div>
                            </div>

                            <div class="flex justify-between items-start mb-2">
                                <div class="flex flex-col gap-1 pr-12">
                                    <h5 class="font-bold text-sm group-hover:text-indigo-600 transition-colors leading-tight">{{ ticket.title }}</h5>
                                    <span class="text-[10px] text-slate-400 font-mono">#{{ ticket.id }}</span>
                                </div>
                                <div class="absolute top-3 right-3 flex gap-1">
                                    <div class="relative">
                                        <button (click)="toggleMoveMenu(ticket.id, $event)" class="p-1.5 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-all" title="Mover para...">⇄</button>
                                        @if (movingTicketId() === ticket.id) {
                                            <div class="absolute right-0 top-full mt-1 w-40 bg-white border border-slate-200 rounded-lg shadow-xl z-10 py-1" (click)="$event.stopPropagation()">
                                                @for (targetCol of columns; track targetCol.id) {
                                                    @if (targetCol.id !== col.id) {
                                                        <button (click)="initiateMove(ticket, col.id, targetCol.id)" class="w-full text-left px-3 py-2 text-[11px] font-bold text-slate-600 hover:bg-indigo-50 hover:text-indigo-600 transition-colors">
                                                            Mover para {{ targetCol.title }}
                                                        </button>
                                                    }
                                                }
                                            </div>
                                        }
                                    </div>
                                    <button (click)="openEditModal(ticket)" class="p-1.5 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-all">✎</button>
                                </div>
                            </div>
                            <p class="text-xs text-slate-500 dark:text-slate-400 line-clamp-2 mb-3 leading-relaxed">{{ ticket.description }}</p>

                            <!-- Metadata Icons -->
                            <div class="flex flex-wrap gap-2 mt-auto pt-2">
                                @if (ticket.data.startDate) {
                                    <div class="flex items-center gap-1 text-[10px] bg-slate-100 text-slate-600 px-2 py-1 rounded-md font-medium">📅 {{ ticket.data.startDate }}</div>
                                }
                                @if (ticket.data.prLink) {
                                    <div class="flex items-center gap-1 text-[10px] bg-purple-50 text-purple-700 px-2 py-1 rounded-md font-medium">🔗 PR</div>
                                }
                            </div>
                            <a
                                routerLink="/orientacoes/detalhe"
                                class="absolute bottom-3 right-3 inline-flex items-center gap-2 rounded-full border border-primary bg-primary px-3 py-1.5 text-[11px] font-bold text-white shadow-sm transition-colors"
                                title="Ver detalhes"
                            >
                                <i class="pi pi-external-link text-[10px] text-white" style="color: #ffffff !important"></i>
                                Detalhes
                            </a>
                        </app-card-container>
                    }

                    <button
                        (click)="openNewTicketModal(col.id)"
                        class="w-full py-3 mt-2 border-2 border-dashed border-slate-300/60 dark:border-slate-500/60 rounded-xl text-slate-400 dark:text-slate-400 hover:text-indigo-600 dark:hover:text-indigo-400 hover:border-indigo-300 dark:hover:border-indigo-500 hover:bg-indigo-50/30 dark:hover:bg-indigo-900/20 text-xs font-semibold flex justify-center items-center gap-1.5 transition-all group"
                    >
                        + Adicionar Ticket
                    </button>
                </div>
            </div>
        }
    </div>

    <!-- Modal de Transição de Etapa -->
    @if (pendingMove()) {
        <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div class="absolute inset-0 bg-slate-900/60 backdrop-blur-md" (click)="cancelMove()"></div>
            <div class="relative bg-white w-full max-w-md rounded-2xl shadow-2xl overflow-hidden">
                <div class="p-6">
                    <div class="flex justify-between items-center mb-6">
                        <div class="flex items-center gap-2 text-slate-400 text-[10px] font-black uppercase tracking-widest">
                            <span class="bg-slate-100 px-2 py-1 rounded">{{ getColumnTitle(pendingMove()?.from) }}</span>
                            <span>→</span>
                            <span class="bg-indigo-50 text-indigo-600 px-2 py-1 rounded">{{ getColumnTitle(pendingMove()?.to) }}</span>
                        </div>
                        <button (click)="cancelMove()" class="text-slate-400 hover:text-slate-600 p-1 rounded-full hover:bg-slate-100">✕</button>
                    </div>

                    <!-- Conteúdo Dinâmico do Modal baseada na coluna destino -->
                    @switch (pendingMove()?.to) {
                        @case ('doing') {
                            <div class="space-y-4">
                                <h3 class="text-lg font-bold">🚀 Iniciar Trabalho</h3>
                                <div>
                                    <label class="block text-sm font-medium text-slate-700">Responsável</label>
                                    <input type="text" #assignee class="mt-1 block w-full border border-slate-300 rounded-md p-2" placeholder="Nome do dev" />
                                </div>
                                <div>
                                    <label class="block text-sm font-medium text-slate-700">Início</label>
                                    <input type="date" #startDate class="mt-1 block w-full border border-slate-300 rounded-md p-2" />
                                </div>
                                <button (click)="confirmMove({ assignee: assignee.value, startDate: startDate.value })" class="w-full bg-indigo-600 text-white p-3 rounded-xl font-bold">Confirmar</button>
                            </div>
                        }
                        @case ('review') {
                            <div class="space-y-4">
                                <h3 class="text-lg font-bold">🔍 Solicitar Revisão</h3>
                                <div>
                                    <label class="block text-sm font-medium text-slate-700">Link PR</label>
                                    <input type="url" #prLink class="mt-1 block w-full border border-slate-300 rounded-md p-2" placeholder="https://github.com/..." />
                                </div>
                                <button (click)="confirmMove({ prLink: prLink.value })" class="w-full bg-purple-600 text-white p-3 rounded-xl font-bold">Mover para Revisão</button>
                            </div>
                        }
                        @case ('done') {
                            <div class="space-y-4">
                                <h3 class="text-lg font-bold">✅ Finalizar</h3>
                                <div>
                                    <label class="block text-sm font-medium text-slate-700">Release Notes</label>
                                    <textarea #notes class="mt-1 block w-full border border-slate-300 rounded-md p-2" rows="3"></textarea>
                                </div>
                                <button (click)="confirmMove({ releaseNotes: notes.value })" class="w-full bg-green-600 text-white p-3 rounded-xl font-bold">Concluir Ticket</button>
                            </div>
                        }
                        @default {
                            <div class="space-y-4">
                                <h3 class="text-lg font-bold">Mover para Backlog</h3>
                                <p class="text-sm text-slate-500">Deseja retornar este item?</p>
                                <button (click)="confirmMove({})" class="w-full bg-slate-800 text-white p-3 rounded-xl font-bold">Confirmar</button>
                            </div>
                        }
                    }
                </div>
            </div>
        </div>
    }

    <!-- Modal Novo / Editar Ticket -->
    @if (showFormModal()) {
        <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div class="absolute inset-0 bg-slate-900/60 backdrop-blur-md" (click)="showFormModal.set(false)"></div>
            <div class="relative bg-white w-full max-w-md rounded-2xl shadow-2xl p-6">
                <h3 class="text-xl font-black mb-6">{{ isEditing() ? 'Editar Ticket' : 'Novo Ticket' }}</h3>
                <div class="space-y-4">
                    <div>
                        <label class="block text-xs font-bold text-slate-500 uppercase mb-1">Título</label>
                        <input type="text" #tTitle [value]="activeTicket()?.title || ''" class="w-full border border-slate-200 rounded-xl p-3 outline-none focus:ring-2 focus:ring-indigo-500" />
                    </div>
                    <div>
                        <label class="block text-xs font-bold text-slate-500 uppercase mb-1">Descrição</label>
                        <textarea #tDesc class="w-full border border-slate-200 rounded-xl p-3 outline-none focus:ring-2 focus:ring-indigo-500" rows="3">{{ activeTicket()?.description || '' }}</textarea>
                    </div>
                    <div class="flex gap-3 mt-6">
                        <button (click)="showFormModal.set(false)" class="flex-1 p-3 border border-slate-200 rounded-xl font-bold">Cancelar</button>
                        <button (click)="saveTicket(tTitle.value, tDesc.value)" class="flex-1 p-3 bg-indigo-600 text-white rounded-xl font-bold">Salvar</button>
                    </div>
                </div>
            </div>
        </div>
    }
</ng-template>

<ng-template #canceladas> tabela cancelados </ng-template>

<ng-template #finalizadas> tabela finalizados </ng-template>
